import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { postResetPasswordForm } from "../../utils/api";
import logo from "../../assets/images/Logo.svg";
import Modal from "../../components/Modal";
import ServiceValue from "../SignUp/ServiceValue/ServiceValue";
import { useAuth } from "../../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";

const ResetPasswordForm = () => {
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isError, setIsError] = useState(false);
  const { accessToken } = useAuth();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const email = queryParams.get('email');
  const navigate = useNavigate();

  const formik = useFormik({
    initialValues: {
      password: "",
      password_confirmation: ""
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .required("Password is required"),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required")
    }),
    onSubmit: async (values) => {
      try {
        const res = await postResetPasswordForm(accessToken, {...values, email, token});

        if (res.data.success) {
          setModalMessage("Password reset successfully!");
          setIsError(false);
          setIsModalOpen(true);

          setTimeout(() => {
            navigate("/login");
          }, 2000)
        }
      } catch (error) {
        setModalMessage(
          error.response?.data?.message || "An error occurred. Please try again."
        );
        setIsError(true);
        setIsModalOpen(true);
      }
    },
  });

  return (
    <div className="min-h-[100vh] w-full sign-up flex items-center justify-center flex-col md:flex-row">
      <div className="w-full h-full flex items-center justify-center md:pt-0 pt-10 md:pb-0 pb-10">
        <div className="flex flex-col items-start gap-[50px] max-w-[513px] w-full">
          <header
            className="inline-flex flex-col items-start justify-center gap-[50px] md:gap-[100px] flex-[0_0_auto] bg-transparent">
            <img className="w-[170.41px] h-[26.57px]" alt="Logo" src={logo} />
            <div className="inline-flex flex-col items-start justify-center gap-[5px] flex-[0_0_auto]">
              <p
                className="w-fit mt-[-1.00px] [font-family:'Inter-SemiBold',Helvetica] font-semibold text-white text-[32px] tracking-[0] leading-[48px]">
                Reset Password
              </p>
            </div>
          </header>
          <form onSubmit={formik.handleSubmit}
                className="gap-[25px] self-stretch w-full flex flex-col items-start flex-[0_0_auto]">
            <div className="gap-3 self-stretch w-full flex flex-col items-start flex-[0_0_auto]">
              <div className="flex flex-col items-start gap-3 self-stretch w-full flex-[0_0_auto] mb-5">
                <label
                  className="w-fit mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]">
                  New Password
                </label>
                <input
                  name="password"
                  className="max-w-[513px] w-full px-[22px] py-[18px] bg-[#0d2c3b] rounded-md border border-solid border-[#444444] mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]"
                  placeholder="................"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                />
                {formik.touched.password && formik.errors.password ? (
                  <div className="text-red-500 text-sm">{formik.errors.password}</div>
                ) : null}
              </div>

              <div className="flex flex-col items-start gap-3 self-stretch w-full flex-[0_0_auto]">
                <label
                  className="w-fit mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]">
                  Confirm Password
                </label>
                <input
                  name="password_confirmation"
                  className="max-w-[513px] w-full px-[22px] py-[18px] bg-[#0d2c3b] rounded-md border border-solid border-[#444444] mt-[-1.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-white text-[15px] tracking-[0] leading-[15px]"
                  placeholder="................"
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password_confirmation}
                />
                {formik.touched.password_confirmation && formik.errors.password_confirmation ? (
                  <div className="text-red-500 text-sm">{formik.errors.password_confirmation}</div>
                ) : null}
              </div>
            </div>

            <div className="flex flex-col items-start gap-[25px] self-stretch w-full flex-[0_0_auto]">
              <button
                type="submit"
                className="all-[unset] box-border flex items-center justify-center gap-2.5 px-[10px] py-3.5 self-stretch w-full flex-[0_0_auto] rounded-[5px] [background:linear-gradient(180deg,rgb(254,100,50)_0%,rgb(248,118,31)_100%)]"
              >
                <span
                  className="w-fit mt-[-1.00px] [font-family:'Inter-SemiBold',Helvetica] font-semibold text-white text-sm tracking-[0] leading-[21px]">
                  Reset Password
                </span>
              </button>
            </div>
          </form>

          {isModalOpen && (
            <Modal
              message={modalMessage}
              isError={isError}
              onClose={() => setIsModalOpen(false)}
            />
          )}
        </div>
      </div>
      <div className="w-full min-h-[100vh] flex items-center justify-center bg-[#001522] md:pt-0 pt-10 md:pb-0 pb-10">
      <ServiceValue />
      </div>
    </div>
  );
};

export default ResetPasswordForm;